export default __webpack_public_path__ + "static/996-6d5aa8e7e09bc56a9dd8e6e76cc7d4f5.gif";